module.exports = __webpack_public_path__ + "img/Illustration-problem@2x.22cc815.png";